import React from 'react'

export const LocalizationContext = React.createContext({
  dict: {},
})
export const LocalizationProvider = LocalizationContext.Provider
export const LocalizationConsumer = LocalizationContext.Consumer
